module.exports = __webpack_public_path__ + "img/header_bg_tc@2x.6a00645e.png";